var messages = {
  alert: {
    cancelButtonText: "取消",
    confirmButtonText: "确认",
    networkError: "网络连接错误",
  },
  meta: {
    homePage: "首页",
    userPage: "我",
    userManagement: "用户管理",
    systemLanguage: "系统语言",
    autoLanguage: "跟随系统",
    search: "搜索",
    noMore: "没有更多了",
    uploadSuccess: "上传成功",
    uploadFail: "上传失败",
    loading: "加载中...",
    privacy1: "用户协议",
    privacy2: "隐私政策",
    privacy3: "运输政策",
    confirm: "确定",
    cancel: "取消",
    copySuccess: "复制成功",
    input: "请输入",
    select: "请选择",
    searchType: "搜索条件",
    allFilter: "全部筛选",
    kefuList: "客服会话",
    reset: "重置",
    yes: "是",
    no: "否"
  },
  home: {
    title: "vTrack 物流驿站",
    freightInquiry: "运价查询",
    freightInquiryDetail: "运价详情",
    orderDetail: "运单详情",
    orderException: "订单异常处理",
    cargoInquiry: "货物查询",
    goodsForecast: "进货预报",
    accountList: "账款往来",
    shippingAddress: "地址管理",
    freightPriceCalculator: "运费计算器",
    nickname: "昵称",
    qrCode: "提货二维码",
    customerNumber: "编号",
    payCompletion: "支付详情",
    pointsList: "积分详情",
    shipNow: "立即发货",
    details: "商品详情"
  },
  auth: {
    login: "登录",
    logInSuccess: "登录成功",
    inputPhoneNumber: "请输入手机号",
    inputEmail: "请输入邮箱",
    inputCorrentPhoneNumber: "请输入正确的手机号",
    inputCorrentEmail: "请输入正确的邮箱",
    phoneNumber: "手机号",
    email: "邮箱",
    inputVcode: "请输入验证码",
    inputUsername: "手机号 / 邮箱 / 客户编号",
    inputPassword: "请输入密码",
    inputCompanyCode: "请输入公司代码",
    register: "注册",
    setAccountInfo: "设置账户信息",
    sendAuthCode: "获取验证码",
    next: "下一步",
    backLogin: "返回登录",
    verificationCodeInfo: "已发送验证码",
    username: "用户名",
    inputPaw: "请输入登录密码",
    inputPaw2: "再次输入密码",
    registerSuccess: "注册成功",
    correctError: "请先输入正确的密码",
    confirm: "确认",
    logout: "退出登录",
    customerNumber: "用户编号",
    companyName: "迎客商服控股（广州）有限公司",
    logoText: "中国快递国际服务",
    codeNotice: "没收到验证码？查查垃圾邮件。"
  },
  address: {
    addAddress: "新建国外收货地址",
    editAddress: "编辑收货地址",
    addressTitle: "国外收货地址",
    postcode: "邮编",
    email: "邮箱",
    input: "请输入",
    select: "请选择",
    receivingName: "收件人姓名",
    phoneNumber: "联系电话",
    country: "国家",
    city: "城市",
    receivingAddress: "收货详细地址",
    isDefault: "是否默认收货地址",
    submit: "提交",
    delete: "删除",
    selectAddress: "请选择地址",
    chinese1: "您的中国专属收货地址",
    chinese2: "仓库简称",
    chinese3: "联系人",
    chinese4: "联系电话",
    chinese5: "地址",
    copy: "点击复制"
  },
  information: {
    title: "编辑个人信息",
    input: "请输入",
    select: "请选择",
    companyName: "公司/个人全称",
    companyNameEn: "企业英文名",
    companyNameSn: "企业简称",
    companyNameContact: "企业联系人",
    legalPerson: "企业法人",
    telePhone: "企业固话",
    webSite: "企业网址",
    address: "企业地址",
    certificate: "营业执照",
    personalPassport: "客户护照号",
    personalID: "客户个人身份证号",
    customerPhone: "客户手机号",
    email: "邮箱",
    country: "国家",
    city: "城市",
    password: "密码",
    submit: "提交",
    alert: "请先完善个人信息",
    name: "名称",
    customerNumber: "账号",
    phoneNumber: "手机号",
    availablePoints: "积分",
    pointsTitle: "我的积分",
    pointsSubTitle: "积分变更记录",
    changeType1: "积分收入",
    changeType2: "积分支出",
    changeType3: "积分回退",
    changeType4: "积分扣回",
    searchBar: "请输入追踪号码",
    validator: "该名称已被使用，可选择以下名称，或自行修改"
  },
  freightInquiry: {
    tableTitle: "收费标准",
    countryName: "国家名称",
    cargoCategory: "运输服务",
    placeHolder: "请选择国家",
    divider: "续重",
    col1: "运输服务",
    col2: "首重重量",
    col3: "首重价格",
    col4: "续重重量",
    col5: "续重价格",
    col6: "运输时长",
    day: "天",
    warehouseContact: "仓库联系人",
    warehousePhone: "仓库联系电话",
    warehouseAddress: "仓库地址",
    copy: "一键复制",
    empty: "暂无数据",
    none: "无",
    remark: "备注"
  },
  cargoInquiry: {
    input: "请输入",
    wbNumber: "运单号",
    search: "查询",
    copy: "复制",
    title1: "运单信息",
    title2: "收货地址",
    title3: "快件信息",
    title4: "货物信息",
    title5: "物流跟踪",
    wbTypeStr: "运输方式",
    logisticsStatus: "物流状态",
    receivingName: "收件人姓名",
    phoneNumber: "联系电话",
    receivingAddress: "详细地址",
    boxNumber: "箱数",
    volume: "体积",
    weight: "重量",
    pol: "发货港",
    pod: "目的港",
    cargoName: "物品名称",
    cargoQuantity: "物品数量",
    goodsValue: "货值",
    currency: "货币",
    quantityUnit: "数量单位",
    numberPackages: "包裹数量",
    chargeableWeight: "计费重量",
    copySuccess: "复制成功",
    wbType1: "空运",
    wbType2: "海运",
    wbType3: "空派",
    wbType4: "海派",
    wbType5: "快递",
    logisticsState1: "运输中",
    logisticsState2: "待提货",
    logisticsState3: "待取件",
    logisticsState4: "派送中",
    logisticsState5: "已签收",
    signTime: "签收时间",
    updateTime: "物流更新时间",
    viewLogistics: "查看物流",
    allFilter: "全部筛选",
    dateRange: "时间范围类型",
    dateType1: "今天",
    dateType2: "近7天",
    dateType3: "近30天",
    dateType4: "自定义时间",
    selectStartDate: "请选择开始日期",
    selectEndDate: "请选择结束日期",
    to: "至",
    startDate: "开始日期",
    endDate: "结束日期",
    reset: "重置",
    confirm: "确定",
    tab1: "未完成",
    tab2: "已完成",
    year: "",
    month: "",
    day: "",
    inputText: "请输入运单号",
    searchText: "搜索",
    filter: "筛选",
  },
  orderDetail: {
    expressNumber: "快递单号",
    cargoTrackingNumber: "货物查询号",
    cargoName: "物品名称",
    cargoQuantity: "物品数量",
    goodsValue: "货值",
    currency: "货币",
    quantityUnit: "数量单位",
    isUnpack: "是否拆包",
    countryName: "国家名称",
    cargoCategory: "运输服务",
    numberPackages: "包裹数量",
    volume: "体积",
    weight: "重量",
    chargeableWeight: "计费重量",
    editOrder: "编辑订单",
    deleteOrder: "删除订单",
    wbNumber: "运单号",
    billState1: "待结账",
    billState2: "已结账",
    billState3: "待审核",
    boxNumber: "箱数",
    inboundBoxNumber: "入库箱数",
    viewLogistics: "查看物流",
    viewBillList: "查看账单",
    payBillList: "支付账单",
    viewShipping: "提货方式",
    viewException: "派送异常",
    exceptionTitle: "异常处理",
    exceptionReason: "派送异常原因",
    confirmReceipt: "确认签收",
    allFilter: "全部筛选",
    select: "请选择",
    cargoSelect: "请先选择国家名称",
    reset: "重置",
    confirm: "确定",
    shippingAlertTitle: "请选择提货方式",
    shippingType1: "到仓自提",
    shippingType2: "申请派送",
    selectAddress: "选择地址",
    receivingName: "收件人",
    phoneNumber: "联系电话",
    receivingAddress: "收货地址",
    state1: "待入仓",
    state2: "已入仓",
    state3: "在途货物",
    state4: "待提货",
    state5: "待派送",
    state6: "已完成",
    state7: "已取消",
    confirmDelete: "是否删除该订单?",
    inputText: "请输入需要搜索的内容",
    search: "搜索",
    filter: "筛选",
    sideWbNumber: "分运单号",
    exceptionText(val) {
      return "转派最多只支持操作3次，您还可以操作" + val + "次";
    },
    eState1: "转派",
    eState2: "退仓",
    exceptionTrim: "最多只能转派3次",
    payType: "支付方式",
    onPay: "立即支付",
    paymentOption1: "支付宝",
    paymentOption2: "微信",
    viewDetail: "查看详情",
    paySuccess: "支付成功",
    payFailure: "支付失败",
    backHome: "返回首页",
    searchType: "搜索条件",
    serviceFee: "服务费",
    availablePoints: "积分",
    deductibleAmount: "可抵扣金额",
    taxFeebearingParty: "税费承担方",
    shipper: "发货人",
    consignee: "收货人",
    completeOrderGoodsValue: "请完善订单货值",
    discount: "首单立减"
  },
  goodsForecast: {
    input: "请输入",
    select: "请选择",
    nextStep: "下一步",
    expressNumber: "快递单号",
    expressNumberPlaceHolder: "请录入将到仓的快递单号",
    cargoName: "物品名称",
    cargoQuantity: "物品数量",
    goodsValue: "货值",
    currency: "货币",
    quantityUnit: "数量单位",
    customUnit: "自定义单位",
    boxNumber: "箱数",
    countryName: "国家名称",
    cargoCategory: "运输服务",
    productImage: "产品图片",
    receivingAddress: "收货地址",
    submit: "提交",
    uploaderText1: "点击上传图片",
    uploaderText2: "支持 jpg、png格式,最大10MB",
    stepperLabel: "添加 / 删除",
    other: "其他",
    isUnpack: "是否拆包",
    question: "去原包，重打包，减体积，省运费",
    createText: "温馨提示: 已完成进货预报,请留意运单详情并完成支付",
    productCategory: "产品类别",
    totalTax: "预估税费",
    taxFeebearingParty: "税费承担方",
    shipper: "发货人",
    consignee: "收货人",
    englishOnly: "只允许输入英文",
    translate: "翻译"
  },
  accountList: {
    accountBalance: "预付运费余额",
    fundType1: "预付运费",
    fundType2: "支付运费",
    fundType3: "换汇入账",
    fundType4: "换汇支出",
    currency: "货币",
    balance: "余额",
    allFilter: "全部筛选",
    fundTypeStr: "资金类型",
    reset: "重置",
    confirm: "确定",
    search: "搜索",
    filter: "筛选",
    input: "请输入"
  },
  paybillList: {
    totalAmount: "应付合计",
    approvedAmount: "已付合计",
    billState1: "待结账",
    billState2: "已结账",
    billState3: "待审核",
    subTotalAmount: "应付小计",
    subApprovedAmount: "已付小计",
    chargeMoney: "收费款项",
    payableBills: "应付账单",
    dialogCurrencyTitle: "请选择支付货币",
  },
  calculator: {
    title: "请先填写信息查询价格",
    input: "请输入",
    select: "请选择",
    length: "长(cm)",
    width: "宽(cm)",
    height: "高(cm)",
    weight: "总重量(kg)",
    search: "查询",
    col1: "运抵国家 / 地区",
    col2: "首重重量",
    col3: "首重价格",
    col4: "续重重量",
    col5: "续重价格",
    col6: "运输时长",
    day: "天",
    empty: "暂无数据",
    remark: "备注",
    orderBy1: "价格升序",
    orderBy2: "价格倒序",
    packageSize: "总体积",
    totalFreight: "预估运费"
  },
  shopping: {
    isCoupon: "优惠",
    isBrand: "品牌",
    isAttestation: "认证",
    isNotEmail: "请先完善您的邮箱",
    productInfo: "产品信息",
    descriptions: "产品描述",
    weight: "重量",
    volume: "体积",
    quantity: "数量",
    inventory: "库存",
    none: "无",
    addShop: "添加到收藏",
    shopCarList: "购物车",
    productList: "商品列表",
    msg1: "产品没有产品价格集合",
    msg2: "产品没有规格",
    msg3: "商品价格找不到对应的产品价格集合",
    msg4: "sku类与此商品价格sku长度不一致,请联系管理员",
    msg5: "sku没有子类,请联系管理员",
    msg6: "商品价格sku在sku类里找不到,请联系管理员",
    msg7: "在商品sku价格集合找不到",
    msg8: "此产品没有库存",
    refresh: "换一批"
  }
};
export default messages;
